import styled from 'styled-components';

export const LoginContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: #e9e5e2;
  background-image: url('/background_login.webp');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const LoginContent = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    margin-top: 20px;
    margin-bottom: 20px;
  }
`;

export const LogoImage = styled.img`
  max-width: 80%;
`;

export const FormSide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginFormWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 15px;
  padding: 15px 30px;
  width: 80%;
  max-width: 400px;
  margin-top: calc(20vh - 180px);

  @media (max-width: 768px) {
    margin-top: 0;
    width: 90%;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  color: #fff;
  display: block;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.textColor};
`;

export const ForgotPassword = styled.a`
  display: block;
  text-align: right;
  color: #fff;
  font-size: 0.9em;
  margin-top: 5px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  background-color: ${({ theme }) => theme.successColor};
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background-color: ${({ theme }) => theme.successColorHover};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.lightGray};
    cursor: not-allowed;
  }
`;

export const AlertError = styled.div`
  background-color: ${({ theme }) => `${theme.errorColor}CC`};
  color: #fff;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
`;

export const Footer = styled.footer`
  color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 5px;
  font-size: 0.8em;
`;
